export default __webpack_public_path__ + "static/media/roadmap.28a92aff.png";